import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AlertTriangle, TrendingUp, Info, CheckCircle2, ArrowRight, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ICONS = { warning: AlertTriangle, info: Info, success: CheckCircle2 };
const TONES = { warning: "text-amber-500 border-amber-500/30 bg-amber-500/5",
                info: "text-blue-500 border-blue-500/30 bg-blue-500/5",
                success: "text-emerald-600 border-emerald-500/30 bg-emerald-500/5" };

export default function AIInsights() {
  const [data, setData] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/ai/insights").then((r) => setData(r.data)); }, []);
  if (!data) return null;
  return (
    <div className="card-sharp p-5" data-testid="ai-insights">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4" style={{ color: "hsl(var(--brand-purple))" }} />
          <div className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">Actionable insights · AI</div>
        </div>
        <div className="text-[10px] text-muted-foreground">{data.insights.length} items</div>
      </div>
      <div className="space-y-2">
        {data.insights.map((ins, i) => {
          const Icon = ICONS[ins.severity] || Info;
          return (
            <div key={i} className={`flex items-start gap-3 p-3 border rounded-sm ${TONES[ins.severity] || ""}`} data-testid={`insight-${i}`}>
              <Icon className="w-4 h-4 shrink-0 mt-0.5" />
              <div className="flex-1 min-w-0">
                <div className="font-medium text-sm">{ins.title}</div>
                <div className="text-xs text-muted-foreground mt-0.5">{ins.detail}</div>
              </div>
              {ins.link && <button onClick={() => nav(ins.link)} className="text-xs flex items-center gap-1 hover:underline" data-testid={`insight-action-${i}`}>{ins.action} <ArrowRight className="w-3 h-3" /></button>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
